import React from 'react';
import { EAgentLandingPageType } from 'types/agent-landing-page';

import Contact from 'components/AgentLanding/Contact/Contact';
import DigitalAd from 'components/AgentLanding/DigitalAd';
import HomeEstimation from 'components/AgentLanding/HomeEstimation/HomeEstimation';
import MetaPixelWrapper from 'components/MetaPixelWrapper';

const HomePage = ({
  agentLandingPageType,
  agentLandingPageToken,
  agentData,
  propertyData,
  similarHomes,
  marketAreaName,
  // Download-report props retained for future use: setIsDownloadingReport, eventId.
}) => {
  if (agentLandingPageType === EAgentLandingPageType.ComparableProperties) {
    return (
      <HomeEstimation
        agentLandingPageToken={agentLandingPageToken}
        agentData={agentData}
        propertyData={propertyData}
        similarHomes={similarHomes}
        // setIsDownloadingReport={setIsDownloadingReport}
        // eventId={eventId}
      />
    );
  }
  if (agentLandingPageType === EAgentLandingPageType.ContactForm) {
    return <Contact agentLandingPageToken={agentLandingPageToken} agentData={agentData} marketAreaName={marketAreaName} />;
  }
  if (agentLandingPageType === EAgentLandingPageType.DigitalAd) {
    return (
      <MetaPixelWrapper>
        <DigitalAd agentLandingPageToken={agentLandingPageToken} agentData={agentData} />
      </MetaPixelWrapper>
    );
  }
  return null;
};

export default HomePage;
